import React, { ReactNode } from 'react';

import { getLocalDate } from 'common/utils';

import { Grid, Typography, Tooltip } from 'e100-react-components';
import { Icon } from 'components';
import { CopyIconButton } from '../CopyIconButton/CopyIconButton';

import { useStyles } from './styles';
import { useIntl } from 'react-intl';
import { HistoryLocation, useGetDuration } from 'entities/navigation';

export const Location = ({ startLocation, endLocation, icon, warningMessage, title }: LocationProps) => {
  const hasWarningMessage = !!warningMessage;
  const classes = useStyles({ hasWarningMessage });
  const { formatMessage } = useIntl();

  const duration = useGetDuration(startLocation.timestampUtc, endLocation?.timestampUtc ?? '');

  return (
    <Grid container spacing={0} alignItems="center" justify="space-between">
      <Grid item xs={12}>
        <div className={classes.textContainer}>
          {icon && <span className={classes.iconContainer}>{icon}</span>}
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" component="p" color="textPrimary" classes={{ root: classes.text }}>
                <b>{title}</b>
              </Typography>
            </Grid>
            <Grid item>
              <Grid container spacing={0} alignItems="center">
                <Grid item xs={12}>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      classes={{
                        root: classes.item,
                      }}
                    >
                      <Typography variant="subtitle2" color="secondary" component="p" classes={{ root: classes.date }}>
                        {`${getLocalDate(startLocation.timestampUtc)}`}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <CopyIconButton
                        title={formatMessage({ id: 'copyСoordinates' })}
                        message={`${startLocation.latitude}, ${startLocation.longitude}`}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {endLocation && (
                  <>
                    <Grid item xs={12}>
                      <Grid container spacing={0}>
                        <Grid
                          item
                          classes={{
                            root: classes.item,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            color="secondary"
                            component="p"
                            classes={{ root: classes.date }}
                          >
                            {`${getLocalDate(endLocation.timestampUtc)}`}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <CopyIconButton
                            title={formatMessage({ id: 'copyСoordinates' })}
                            message={`${endLocation.latitude}, ${endLocation.longitude}`}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography variant="subtitle2" color="secondary" component="p" classes={{ root: classes.date }}>
                        {`Duration: ${duration}`}
                      </Typography>
                    </Grid>
                  </>
                )}

                {warningMessage && (
                  <Grid item>
                    <Tooltip
                      title={<span dangerouslySetInnerHTML={{ __html: warningMessage }} />}
                      enterDelay={0}
                      enterTouchDelay={0}
                    >
                      <Icon
                        kind={'warningOutlined'}
                        classes={{
                          root: classes.warningIcon,
                        }}
                      />
                    </Tooltip>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item xs={12}>
        <br />
      </Grid>
    </Grid>
  );
};

interface LocationProps {
  icon?: ReactNode;
  title?: string;
  startLocation: HistoryLocation;
  endLocation?: HistoryLocation;
  warningMessage?: string | null;
}
